import styled from '@emotion/styled';
import { css, Select } from '@mui/material';
import { colors } from 'theme/colors';
import FormControl from '@mui/material/FormControl';
import { ESelectSizesPX, paddingForSize } from 'constants/Select';

export const StyledFormControl = styled(FormControl)(() => ({
  width: '100%',
}));

interface IStyledSelect {
  sizePx?: ESelectSizesPX;
}

export const StyledSelect = styled(Select)<IStyledSelect>(({ sizePx }) => ({
  '#select': {
    padding: '8px 16px',
    fontSize: 14,
  },
  '& .MuiFormControl-root ': {
    width: '100%',
  },
  '.MuiSelect-select': {
    padding: `${sizePx ? paddingForSize(sizePx) : 5}px 12px`,
    border: 0,
    ':disabled': {
      background: `${colors.gray100} !important`,
      '& input': {
        color: colors.gray400,
        background: `${colors.gray100} !important`,
      },
    },
  },
  '.Mui-disabled': {
    background: `${colors.gray100} !important`,
    '.MuiSelect-select': {
      color: colors.gray400,
      background: `${colors.gray100} !important`,
    },
  },
  '.MuiMenuItem-root': {
    width: '100%',
    fontSize: 14,
    boxSizing: 'border-box',

    '& .MuiSelect-select': {
      height: sizePx ? sizePx : 32,
      padding: 0,
      boxSizing: 'border-box',
    },
  },
  '& .MuiInputBase-input': {
    border: 0,
  },
  '& .MuiInputBase-root': {
    height: sizePx ? sizePx : 32,
  },
  '#daysQuantity': {
    boxSizing: 'border-box',
    padding: '6px 12px',
    width: 65,
    height: sizePx ? sizePx : 32,
    display: 'flex',
    alignItems: 'flex-end',
  },
}));

export const StyledInnerWrapper = styled.div<IStyledSelect>`
  font-size: 14px;
  ${(props: IStyledSelect) => css`
    height: ${props.sizePx ? `${props.sizePx}px` : '32px'};
  `}

  & .MuiOutlinedInput-root {
    width: 100%;
    padding: 0;
    background-color: ${colors.white};

    ${(props: IStyledSelect) => css`
      height: ${props.sizePx ? `${props.sizePx}px` : '32px'};
    `}

    & fieldset {
      border-color: ${colors.gray400};
      border-width: 1px;
    }

    &:hover:not(.Mui-focused, .Mui-disabled) fieldset {
      border-color: ${colors.primary400};
    }

    &.Mui-focused fieldset {
      border-color: ${colors.primary400};
      border-width: 2px;
    }

    &:active fieldset {
      border-color: ${colors.primary900};
      border-width: 1px;
    }

    &.Mui-error fieldset {
      border-color: ${colors.error800};
      border-width: 1px;
    }
  }
  ${(props: IStyledSelect) => css`
    & .MuiSelect-select {
      font-size: 14px;
      height: ${props.sizePx ? `${props.sizePx}px` : '32px'};
      box-sizing: border-box;
      background-color: ${colors.white};
    }
  `}
`;
